module.exports = __webpack_public_path__ + "static/media/amex-logo.b1aa8650.svg";